export const InvoiceListColumns = [
  {
    title: "公司名称",
    width: 280,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "customerName",
    key: "customerName"
    // scopedSlots: { customRender: "customerName" }
  },
  {
    title: "发票编号",
    width: 280,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "invoiceNo",
    key: "invoiceNo"
    // scopedSlots: { customRender: "invoiceNo" }
  },
  {
    title: "联系人",
    width: 100,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "contactName",
    // scopedSlots: { customRender: "contactName" },
    key: "contactName"
  },
  {
    title: "联系人电话",
    width: 130,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "contactTel",
    key: "contactTel"
  },
  {
    title: "创建人",
    width: 100,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "creatorName",
    key: "creatorName"
  },
  {
    title: "发票金额",
    width: 120,
    align: "center",
    ellipsis: true,
    resizable: true,
    key: "invoiceMoney",
    // dataIndex: "invoiceMoney",
    scopedSlots: { customRender: "invoiceMoney" }
  },
  {
    title: "发票时间",
    width: 180,
    align: "center",
    ellipsis: true,
    resizable: true,
    key: "invoiceTime",
    scopedSlots: { customRender: "invoiceTime" }
  },
  {
    title: "产品编号",
    width: 130,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "projectNo",
    key: "projectNo"
  },
  {
    title: "合同编号",
    width: 140,
    align: "center",
    ellipsis: true,
    resizable: true,
    dataIndex: "contractNo",
    key: "contractNo"
  },
  {
    title: "操作",
    width: 88,
    align: "center",
    className: "erp-table-operation-col",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]
